import { z } from 'zod';

export const MyBenchAskHowModalSchema = z.object({
  description: z.string().max(300),
});

export type MyBenchAskHowModalType = z.infer<typeof MyBenchAskHowModalSchema>;
